module.exports = __webpack_public_path__ + "static/media/VisbyCF-Heavy.0297483d.woff";